import { useEffect, useState } from "react";
import { BsInfoCircle } from "react-icons/bs"
import { FiUpload } from "react-icons/fi"
import BackComponent from "../../../../components/BackArrow";
import { useParams } from "react-router-dom";
import WebService from "../../../../utility/WebService";
import { Controller, useForm } from "react-hook-form";
import CustomDropdown from "../../../../components/Select/CustomDropdown";
import { Label } from "../../../../components/Label/Label";
import SucessModal from "../../../../components/SucessModal/Sucess";
import WarningModal from "../../../../components/Warning/Warning";
import loader from "../../../../assets/images/button-loader.svg"
import toast from "react-hot-toast";
import CustomDatePicker from "../../../../components/DatePicker/CustomDatePicker";
import HelperService from "../../../../utility/HelperService";
import moment from "moment";
import { useNavigate, useLocation } from "react-router-dom";
import Loader from '../../../../components/Loader/Loader';

const AddAgreement = () => {
    const {
        register,
        handleSubmit,
        control,
        setValue,
        watch,
        reset,
        formState: { errors },
    } = useForm();
    let { id } = useParams();
    let { p_id } = useParams();
    const watchAllFields = watch();
    const [clientOption, setClientOption] = useState<any[]>([]);
    const [clientValue, setClientValue] = useState<any>();
    const [isLoading, setLoading] = useState(false);
    const [sucessMessage, setSucessMessage] = useState<any>()
    const [isShowSucessModal, setShowSucessModal] = useState(false);
    const [warningMessage, setWarningMessage] = useState<any>()
    const [isShowWarningModal, setShowWarningModal] = useState(false);
    const [image, setImage] = useState<any>({});
    const [documentName, setDocumentName] = useState('');
    const [agreementTypeSelected, setAgreementTypeSelected] = useState<any>();
    const [endDate, setEndDate] = useState(null);
    const [startDate, setStartDate] = useState('');
    const [newStartDate, setNewStartDate] = useState<any>(new Date())
    const { pathname, state } = useLocation();
    const [showLoader, setShowLoader] = useState(false);
    const currentPath = window.location.pathname;
    const isRenewAgreement = currentPath.includes("renew-agreement");

    useEffect(() => {
        getStartDate();
        if(id){
            getDetail(id);
        }
        getAllClientList();
        // console.log(convertedDate)
    }, []);
    const getStartDate = (date?: number) => {
        const dates = date ? new Date(date) : new Date();
        const todaysStartDate: any = new Date(dates.getTime());
        const convertedDate: any = moment.utc(todaysStartDate).format("YYYY-MM-DD");
        setValue("start_date", convertedDate);
        setStartDate(convertedDate);
    };
    // console.log(startDate)
    const getAllClientList = () => {
        WebService.getAPI({
            action: `/v2/UserProfile/GetAllClientList`,
            body: null
        })
            .then((res: any) => {
                var array: any = [];
                for (var i in res.list) {
                    array.push({ id: res.list[i].id, value: res.list[i].name });
                }
                setClientOption(array);
                if (id) {
                    setClientValue(id)
                }
            })
            .catch((e) => {
            })
    }
const handleNewStartDate =(data:any)=>{
    const date = new Date(data);
    const dateString = date.toISOString().split("T")[0];
    setNewStartDate(dateString);
    
}

const getDetail = (id :any) =>{
    setShowLoader(true);
        WebService.getAPI({
            action: `/v2/ClientAgreements/GetAgreementDetails?id=${id}&p_id=${p_id}`,
            body: null
        })
            .then((res: any) => {
                setShowLoader(false);
                reset(res.result);
                if(isRenewAgreement){
                    const endDate = res.result.end_date; 
                    const newStartDate = endDate ? new Date(endDate) : new Date();
                    newStartDate.setDate(newStartDate.getDate() + 1);
                    const formattedStartDate = moment(newStartDate).format("YYYY-MM-DD");
                    setValue("start_date", endDate ? formattedStartDate : moment(newStartDate).format('YYYY-MM-DD'));
                    setStartDate(formattedStartDate); 
                    setValue("duration_type", '');
                }else{
                    setStartDate(res.result.start_date);
                    setValue("duration_type", res.result.duration_type);
                    if(res.result != ""){
                        setValue('start_date', res.result.start_date);
                    }else{
                        getStartDate();
                    }
                    setValue('end_date', res.result.end_date);
                    setValue('document_name' , res.result.document_name);
                    setDocumentName(res.result.display_document_name);
                    setImage(res.result.document_name)
                    setAgreementTypeSelected(res.result.agreement_type);
                    setValue('agreement_type' , res.result.agreement_type);
                    setEndDate(res.result.end_date);
                }
            })
            .catch(() => {
                setShowLoader(false);
            });
}

    const onSave = (data: any) => {    
        data.is_renewal = isRenewAgreement ? 1 : 0  
        let fileName = image.name ? image.name : image;
        let extension = fileName.split(".").pop();
        if (extension == "pdf") {
            var form = new FormData();
            form.append('client_id', id ? id : data.client_id);
            if(p_id){
            form.append('p_id', p_id );
            }
            form.append('agreement_type', data.agreement_type);
            form.append('duration_type', data.duration_type);
            form.append('start_date', data.start_date ? data.start_date : "");
            form.append('end_date', data.end_date ? data.end_date : "" );
            form.append('is_renewal', data.is_renewal);
            if (image) {
                form.append('ClientAgreements[original_agreement]', image);
            }
            setLoading(true);
            WebService.fileUploadAPI({
                action: `/v2/ClientAgreements/AddAggrement`,
                body: form,
            })
                .then((res: any) => {
                    setShowSucessModal(true);
                    setSucessMessage(res.message);
                    goBack();
                })
                .catch((e) => {
                    setShowWarningModal(true);
                    setWarningMessage(e.response.data.message)
                    setLoading(false);
                });
        } else {
            setShowWarningModal(true);
            setWarningMessage("File type must be PDF")
        }
    };

    const goBack = () => {
        window.history.back();
    };

    const onLoadImage = (event: any) => {
        const { files } = event.target;
        if (files && files[0]) {
            const fileSize = files[0].size / 1024 / 1024; // size in MB
            if (fileSize > 15) {
                toast.error('File size should not exceed 15 MB');
            } else {
            setDocumentName(files[0].name);
            setValue("document_name", files[0].name)
            setImage(files[0])
            }
        }
        event.target.value = '';
    };

    const warningCloseModal = () => {
        setShowWarningModal(false)
        setLoading(false);
    };

    const sucessCloseModal = () => {
        setShowSucessModal(false)
        setLoading(false);
    }

    const agreementType = [
        { id: "AADHAR_E_SIGN", value: "Aadhar E-Sign" },
        { id: "E_SIGN", value: "Normal Wet E-sign" },
        // { id: "SCANED_BY_CLIENT", value: "Physical copy scanned by client" },
        { id: "SCANED_BY_BOTH", value: "Physical copy scanned by both parties" }
    ]
    return (
        <>
            <SucessModal
                show={isShowSucessModal}
                isClose={sucessCloseModal}
                message={sucessMessage}
            />
            <WarningModal
                show={isShowWarningModal}
                isClose={warningCloseModal}
                message={warningMessage}
            />
            <Loader show={showLoader} />
            <div className="page-content-wraper">
                <form onSubmit={handleSubmit(onSave)}>
                    <div className="grid grid-cols-2 gap-5 mb-3">
                        {/* <div> <BackComponent title={id ? `Create Agreement : ${state?.name}`: 'Add Agreement'} /></div> */}
                        <div> <BackComponent title={id ? ( id ? (isRenewAgreement ? (`Renew Agreement : ${state?.name}`) : (`Edit Agreement : ${state?.name}`)) : `Create Agreement : ${state?.name}`) : 'Add Agreement'} /></div>
                    </div>
                    <div className="rounded-xl bg-white p-4 mb-4">
                        <div className=" grid grid-cols-5 gap-5 form-style">
                            {!id &&
                            <div className="mb-2">
                                <label className="label">
                                    Client<span className=" text-red-600">*</span>
                                </label>
                                <Controller
                                    control={control}
                                    name="client_id"
                                    rules={{ required: true }}
                                    render={({ field }) => (
                                        <CustomDropdown
                                            isDisable={id ? true : false}
                                            isSearchable={true}
                                            options={clientOption}
                                            selected={clientValue}
                                            onChange={(data: any) => {
                                                field.onChange(data.id)
                                                setClientValue(data.id);
                                            }}
                                        />
                                    )}
                                />
                                <div>
                                    {errors.client_id && (
                                        <Label
                                            title={"Please Select Client."}
                                            modeError={true}
                                        />
                                    )}
                                </div>
                            </div>
                            }
                            <div className="mb-2">
                                <label className="label">
                                    Agreement Type<span className=" text-red-600">*</span>
                                </label>
                                <Controller
                                    control={control}
                                    name="agreement_type"
                                    rules={{ required: true }}
                                    render={({ field }) => (
                                        <CustomDropdown
                                            isSearchable={true}
                                            options={agreementType}
                                            selected={agreementTypeSelected}
                                            onChange={(data: any) => {
                                                field.onChange(data.id)
                                                setAgreementTypeSelected(data.id);
                                            }}
                                        />
                                    )}
                                />
                                <div>
                                    {errors.agreement_type && (
                                        <Label
                                            title={"Please Select Agreement Type."}
                                            modeError={true}
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="mb-2">
                                <div className="">
                                    <label className=" mb-0 mr-4">Duration Type<span className=" text-red-600">*</span></label>
                                    <div className="flex mt-3">
                                        <div className="flex items-center mr-4">
                                            <input
                                                id="Perpetual"
                                                type="radio"
                                                value={'Perpetual'}
                                                className="custom-radio"
                                                {...register("duration_type", {
                                                    required: true,
                                                })}
                                            />
                                            <label htmlFor="Perpetual" className="block text-sm font-medium text-gray-700">Perpetual</label>
                                        </div>
                                        <div className="flex items-center">
                                            <input
                                                id="non_Perpetual"
                                                type="radio"
                                                value={'non_Perpetual'}
                                                className="custom-radio"
                                                {...register("duration_type", {
                                                    required: true,
                                                })}
                                            />
                                            <label htmlFor="non_Perpetual" className="ml-3 block text-sm font-medium text-gray-700">Non Perpetual</label>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    {errors.duration_type && (
                                        <Label title={"Please Select Duration Type."} modeError={true} />
                                    )}
                                </div>
                            </div>
                            
                            {(watchAllFields.duration_type == "Perpetual" || watchAllFields.duration_type == "non_Perpetual") &&
                            <div className="mb-2">
                                <label className="label">
                                    Start Date <span className="text-red-600">*</span>
                                </label>
                                <Controller
                                    control={control}
                                    name="start_date"
                                    rules={{ required: true }}
                                    render={({ field }) => (
                                        <CustomDatePicker
                                            // minData={agreementTypeSelected == "AADHAR_E_SIGN" || agreementTypeSelected == "E_SIGN"? new Date() : undefined}
                                            // maxData={agreementTypeSelected == "SCANED_BY_BOTH" ? new Date() : undefined}
                                            selected={startDate}
                                            isDisabled={isRenewAgreement ? true : false}
                                            onChange={(data: any) => {
                                                handleNewStartDate(data);
                                                field.onChange(data);
                                            }}
                                        />
                                    )}
                                />
                                {errors.start_date && (
                                    <Label title={"Please Select Start Date."} modeError={true} />
                                )}
                            </div>
                            }
                              {watchAllFields.duration_type == "non_Perpetual" && 
                            <div className="mb-2">
                                <label className="label">
                                    End Date <span className="text-red-600">*</span>
                                </label>
                                <Controller
                                    control={control}
                                    name="end_date"
                                    rules={{ required: true }}
                                    render={({ field }) => (
                                        <CustomDatePicker
                                            minData={agreementTypeSelected == "AADHAR_E_SIGN" || agreementTypeSelected == "E_SIGN" && newStartDate? new Date(newStartDate) : agreementTypeSelected == "SCANED_BY_BOTH"?new Date(newStartDate):''}
                                            // maxData={agreementTypeSelected == "SCANED_BY_BOTH" ? new Date() : undefined}
                                            selected={endDate}
                                            onChange={(data: any) => {
                                                field.onChange(data);
                                            }}
                                        />
                                    )}
                                />
                                {errors.end_date && (
                                    <Label title={"Please Select End Date."} modeError={true} />
                                )}
                            </div>
}
                            <div className="mb-2">
                                <div className="mb-2 display-none" >
                                    <label className="label">
                                        First Name<span className=" text-red-600">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="dummy_input"
                                        className="form-control"
                                        {...register("document_name", {
                                            required: true,
                                        })}
                                    />
                                </div>
                                <label className="label">Upload Document <span className=" text-red-600">*</span></label>
                                <div className="flex w-70" >

                                    <label className="block flex justify-center bg-brand rounded-md py-1 text-sm items-center cursor-pointer hover:bg-violet-600">
                                        <span className=" absolute text-white" >
                                            <FiUpload className="mr-1 inline" size={20} />
                                            Upload Document</span>
                                        <input type="file" className="block w-40 text-sm text-slate-500  opacity-0" title=""
                                            onChange={(e: any) => {
                                                onLoadImage(e)
                                            }
                                            }
                                        />
                                    </label>
                                    <BsInfoCircle className="ml-4 mt-2 cursor-pointer" title="Valid file types are doc,docx,pdf,bmp,jpg,jpeg,gif,png,ppt,pptx,xls,xlsx,txt. Max size of each file is 15MB" />
                                </div>
                                <div >
                                    {!watchAllFields.document_name && errors.document_name && (
                                        <Label
                                            title={"Please Upload Document"}
                                            modeError={true}
                                        />
                                    )}
                                </div>
                                {documentName}
                            </div>
                        </div>
                    </div>
                    <div className="text-center mt-4">
                        <button type="button" className="btn btn-white mr-3" onClick={goBack}>Cancel</button>
                        <button type="submit" className="btn btn-brand" >
                            {isLoading && <img src={loader} className='spinner' />}{p_id ? "Save" : "Generate"}</button>
                    </div>
                </form>
            </div>
        </>
    )
}
export default AddAgreement;
